module.exports = __webpack_public_path__ + "img/self.443643ee.png";